import styled from 'styled-components';

export const Wrapper = styled.div`
`;

export const StaffWrapper = styled.div`
    .card-container {
        width: 97%;
        margin: 2rem 0rem 0rem 1rem;
        padding: 3.5rem;
        background-color: #F6F6F6;
        height: 250px;
        .flex-content {
            display: flex;
            justify-content: space-between;
        }
        .content-1 {
            font-size: 25px;
            font-weight: bold;
            color: #000;
        }
        .content-2 {
            margin-top: 5px;
            font-size: 13px;
            color: #000;
        }
        .invite-btn {
            width: 120px;
        }
    }
    .table-container {
        padding: 3rem  
        .anchor {
            color: #3A4FFF;
            text-decoration: underline;
            cursor: pointer;
        }
    }
`